import 'whatwg-fetch'
import md5 from 'md5'

import config from '../../../config/config'

const BASE_API_DOMAIN = config.qobuzapi.base_url
const BASE_PORT = config.qobuzapi.base_port
const BASE_METHOD = config.qobuzapi.base_method

const APP_ID = config.qobuzapi.app_id
const APP_SECRET = config.qobuzapi.app_secret

const CACHE_DELAY = 1800 // 30 minutes
const CACHE_MAX_REQUESTS_STORED = 80

export class QbAjaxRequest {

	static API_DOMAIN = BASE_API_DOMAIN
	static API_BASE_URL = `${BASE_API_DOMAIN}${BASE_METHOD}`

	static setApiBaseURL(domain) {
		if (domain === 'default') {
			this.API_DOMAIN = BASE_API_DOMAIN
			this.API_BASE_URL = `${BASE_API_DOMAIN}${BASE_METHOD}`
		} else if (domain && typeof(domain) === 'string') {
			this.API_DOMAIN = domain
			this.API_BASE_URL = `${domain}${BASE_METHOD}`
		}
	}

	static cacheManager = {}

	static clearCache() {
		this.cacheManager = null
		this.cacheManager = {}
	}

	static clearCachePlaylists(playlists) {
		for (const i in this.cacheManager) {
			for (const j in playlists) {
				if (i.indexOf(`get?playlist_id=${playlists[j]}`) > -1) {
					delete(this.cacheManager[i])
				}
			}
		}
	}

	static genSignedRequest(utimestamp) {
		const myObj = this._arguments
		const keys = []
		for (const k in myObj) {
			if (myObj.hasOwnProperty(k)) {
				keys.push(k)
			}
		}
		keys.sort()
		const len = keys.length
		let queryString = ''
		for (let i = 0; i < len; i++) {
			const k = keys[i]
			queryString += `${k}${myObj[k]}`
		}

		this._raw_sig = this._object_wanted + this._method_wanted + queryString + utimestamp + APP_SECRET

		return md5(this._raw_sig)
	}

	static arrayToURLQuery(arrayjs) {
		return Object.keys(arrayjs).map((key) => (
			`${encodeURIComponent(key)}=${encodeURIComponent(arrayjs[key])}`
		)).join('&')
	}


	// Méthode pour récupérer les résultats d'une méthode get de l'api qobuz

	static get(object, method, args, signed, cacheEnabled) {
		this._object_wanted = object
		this._method_wanted = method
		this._arguments = args || ''

		let cacheOn = cacheEnabled
		let params

		if (signed) {
			const time = `${Math.floor(new Date().getTime() / 1000)}`
			const sign = this.genSignedRequest(time)
			params = Object.assign(
				{
					request_ts: time,
					request_sig: sign
				},
				this._arguments
			)
		} else {
			params = this._arguments
		}
		params = this.arrayToURLQuery(params)


		if (this._object_wanted === 'user' && this._method_wanted === 'login') {
			params += `&device_manufacturer_id=${this._DEVICE_MANUFACTURER_ID}`
		}
		params = params === '' ? '' : `?${params}`

		const headerArgs = {}
		if (this._user_auth_token) {
			headerArgs['X-User-Auth-Token'] = `${this._user_auth_token}`
		}
		headerArgs['X-App-Id'] = `${APP_ID}`

		const callToken = `${object}/${method}${params}`
		const url = `${this.API_BASE_URL}${callToken}`

		let response
		const now = Math.floor(new Date().getTime() / 1000)

		if (Object.keys(this.cacheManager).length + 1 > CACHE_MAX_REQUESTS_STORED) {
			for (const i in this.cacheManager) {
				delete(this.cacheManager[i])
				break
			}
		}

		// si cest des grosses requetes d'import, on desactive le cache
		if (params.indexOf('limit=5000') > -1) {
			cacheOn = false
		}

		if (cacheOn && this.cacheManager[callToken] && this.cacheManager[callToken].ts >= now - CACHE_DELAY) {
			response = Promise.resolve(this.cacheManager[callToken].response).then((r) => (
				JSON.parse(r)
			))
		} else {
			const self = this
			response = fetch(
				url,
				{
					method: 'GET',
					headers: {
						...headerArgs
					}
				}
			)
				.then((res) => (
					res.json()
				))
				.then((json) => {
					if (cacheOn) {
						self.cacheManager[callToken] = {
							ts: now,
							response: JSON.stringify(json)
						}
					}
					return json
				})
		}

		return response
	}

	static setDeviceId(deviceId) {
		this._DEVICE_MANUFACTURER_ID = deviceId
	}

	static setAuthToken(token) {
		this._user_auth_token = token
	}

	// Méthode pour récuperer les résultats d'une méthode POST de l'api qobuz

	static post(object, method, args) {
		this._object_wanted = object
		this._method_wanted = method
		this._arguments = args || ''

		const url = `${this.API_BASE_URL}${object}/${method}`

		let params

		params = this.arrayToURLQuery(this._arguments)
		if (this._object_wanted === 'user' && this._method_wanted === 'login') {
			params += `&device_manufacturer_id=${this._DEVICE_MANUFACTURER_ID}`
		}

		const headerArgs = {}
		if (this._user_auth_token) {
			headerArgs['X-User-Auth-Token'] = `${this._user_auth_token}`
		}
		headerArgs['X-App-Id'] = `${APP_ID}`

		const options = {
			method: 'POST',
			body: params,
			headers: {
				'content-type': 'application/x-www-form-urlencoded',
				...headerArgs
			}
		}

		return fetch(
			url,
			options
		).then(
			(res) => (
				res.json()
			)
		).then(
			(json) => (
				json
			)
		)
	}
	// Méthode pour récuperer les résultats d'une méthode POST de l'api qobuz

	static postJson(object, method, args) {
		this._object_wanted = object
		this._method_wanted = method
		this._arguments = {}

		const time = `${Math.floor(new Date().getTime() / 1000)}`
		const sign = this.genSignedRequest(time)
		const paramsUrl = {
			request_ts: time,
			request_sig: sign
		}
		const url = `${this.API_BASE_URL}${object}/${method}?${this.arrayToURLQuery(paramsUrl)}`

		const headerArgs = {}
		if (this._user_auth_token) {
			headerArgs['X-User-Auth-Token'] = `${this._user_auth_token}`
		}
		headerArgs['X-App-Id'] = `${APP_ID}`
		const options = {
			method: 'POST',
			body: JSON.stringify(args),
			headers: {
				'content-type': 'application/json',
				...headerArgs
			}
		}

		return fetch(url, options)
			.then(res => res.json())
	}
}




// WEBPACK FOOTER //
// ./src/utils/business/qbrequest.js